import {useAuth} from './use-auth';

/**
 * Hook per accedere ai dettagli dell'utente backoffice
 * Include utilities per verificare ruoli e permessi
 */
export const useBackofficeUser = () => {
  const {backofficeUser, refreshBackofficeUser, loading} = useAuth();

  return {
    backofficeUser,
    isAdmin: backofficeUser?.is_admin ?? false,
    isActive: backofficeUser?.status === 'active',
    loading,
    refreshBackofficeUser,
  };
};
